/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface ProgramReferencesAssignmentDto
 */
export interface ProgramReferencesAssignmentDto {

    /**
     * Assignment identifier
     *
     * @type {number}
     * @memberof ProgramReferencesAssignmentDto
     */
    id: number;

    /**
     * Display name of the member the assignment belongs to
     *
     * @type {string}
     * @memberof ProgramReferencesAssignmentDto
     * @example Mario Rossi
     */
    member: string;

    /**
     * The member, for linking
     *
     * @type {JoinEntityDto}
     * @memberof ProgramReferencesAssignmentDto
     */
    memberRef: JoinEntityDto;

    /**
     * Current status of the assignment
     *
     * @type {string}
     * @memberof ProgramReferencesAssignmentDto
     */
    status: ProgramReferencesAssignmentDtoStatusEnum;

    /**
     * Assignment start date (ISO 8601)
     *
     * @type {string}
     * @memberof ProgramReferencesAssignmentDto
     */
    startAt: string | null;

    /**
     * Assignment end date (ISO 8601)
     *
     * @type {string}
     * @memberof ProgramReferencesAssignmentDto
     */
    endAt: string | null;

    /**
     * Whether the assignment was created by the practitioner making the request. When false, it belongs to another practitioner.
     *
     * @type {boolean}
     * @memberof ProgramReferencesAssignmentDto
     */
    own: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum ProgramReferencesAssignmentDtoStatusEnum {
    SCHEDULED = 'SCHEDULED',
    RESCHEDULED = 'RESCHEDULED',
    INPROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    DELAYED = 'DELAYED',
    MISSED = 'MISSED',
    NOTCOMPLETED = 'NOT_COMPLETED',
    SKIPPED = 'SKIPPED',
    DELETED = 'DELETED'
}

